// 예약 마감 시간(reservationHours) 관련 공용 상수.
// 값은 "체험 시작 N시간 전까지 예약을 받는다"는 의미이며, 240시간 = 10일 전 마감.
// 어드민/호스트 상품 등록·수정 폼의 검증 상한과 드롭다운 옵션이 이 값을 공유한다.
export const RESERVATION_HOURS_MAX = 240;

// 예약 마감 시간 드롭다운에 노출하는 선택지(시간 단위). 마지막 값은 RESERVATION_HOURS_MAX와 일치한다.
export const RESERVATION_HOUR_OPTIONS = [6, 12, 18, 24, 30, 36, 48, 60, 72, 96, 120, 168, 240];
